/**
 * Ce qu'a donné une vérification de la santé d'une entreprise (INSEE + BODACC).
 * Partagé : le serveur le renvoie dans `resultat`, la fiche le lit pour choisir
 * son message — « mis à jour » n'est pas « SIRET inexistant ».
 */
export const RESULTAT_ENRICHISSEMENT = Object.freeze({
  OK: 'ok',
  INTROUVABLE: 'introuvable',
  INDISPONIBLE: 'indisponible',
  SANS_SIRET: 'sans_siret'
});
